import changeInspectors from "./changeInspectors";
import samplingRetests from "./samplingRetests";

const applicationProcessingService = [
    {
        matcher: 'applicationProcessing/changeInspectors',
        reply: config => {
            return [200, changeInspectors];
        }
    },
    {
        matcher: /applicationProcessing\/changeInspectors\/(.*)/,
        reply: config => {
            const id = /applicationProcessing\/changeInspectors\/(.*)/.exec(config.url)[1];
            const data = changeInspectors.find(item => item.uuid === id);
            return [200, data];
        }
    },
    {
        matcher: 'applicationProcessing/samplingRetests',
        reply: config => {
            return [200, samplingRetests];
        }
    },
    {
        matcher: /applicationProcessing\/samplingRetests\/(.*)/,
        reply: config => {
            const id = /applicationProcessing\/samplingRetests\/(.*)/.exec(config.url)[1];
            const data = samplingRetests.find(item => item.uuid === id);
            return [200, data];
        }
    },
]

export default applicationProcessingService;